import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { PhoneNumberHelper } from '../../../helpers/phoneNumber.helper';
import { PhoneNumberModel, PrefixModel } from '../../../models/phone-number.model';
import { SupplierContactModel } from '../../../models/supplier-contact.model';
import { UserProfileModel } from '../../../models/user-profile.model';

@Component({
  selector: 'form-list-phone-input',
  templateUrl: './form-list-phone-input.component.html',
  styleUrls: ['./form-list-phone-input.component.scss'],
})
export class FormListPhoneInputComponent implements OnInit {
  @Input() form: UntypedFormGroup;
  @Input() fb: UntypedFormBuilder;
  @Input() contact: SupplierContactModel | UserProfileModel;
  @Input() isUpdateMode = false;

  prefixes: PrefixModel[] = [];
  selectedCountry: PrefixModel;
  contactPhoneNumbers: PhoneNumberModel[] = [];

  constructor() {}

  ngOnInit(): void {
    this.initData();
    this.initForm();
  }

  initData(): void {
    this.prefixes = PhoneNumberHelper.loadEUCountries();
    this.selectedCountry = PhoneNumberHelper.getPrefix(this.prefixes);

    if (this.isUpdateMode) {
      this.contactPhoneNumbers = this.contact.phoneNumbers;
    }
  }

  initForm(): void {
    if (this.isUpdateMode && this.contactPhoneNumbers?.length) {
      this.contactPhoneNumbers.forEach(phone => {
        const matchedPrefix = this.prefixes.find(p => p.code === phone.prefix?.code);

        const phoneNumberGroup = this.fb.group({
          prefix: [matchedPrefix || this.selectedCountry, Validators.required],
          phoneNumber: [phone.phoneNumber || null, this.phoneNumberValidator.bind(this)],
        });

        this.phoneNumbers.push(phoneNumberGroup);
        this.listenToPhoneNumberChanges(phoneNumberGroup, this.phoneNumbers.length - 1);
      });
    } else {
      this.addPhoneNumber();
    }
  }

  listenToPhoneNumberChanges(group: UntypedFormGroup, index: number): void {
    group.get('prefix')?.valueChanges.subscribe(() => {
      group.get('phoneNumber')?.updateValueAndValidity({ onlySelf: true });
    });
  }

  get phoneNumbers(): UntypedFormArray {
    return this.form.get('phoneNumbers') as UntypedFormArray;
  }

  addPhoneNumber(): void {
    const phoneNumberGroup = this.fb.group({
      prefix: [this.selectedCountry || null, Validators.required],
      phoneNumber: [null, this.phoneNumberValidator.bind(this)],
    });

    this.phoneNumbers.push(phoneNumberGroup);
    this.listenToPhoneNumberChanges(phoneNumberGroup, this.phoneNumbers.length - 1);
  }

  getPhoneNumberFormGroup(index: number): UntypedFormGroup {
    return this.phoneNumbers.at(index) as UntypedFormGroup;
  }

  removePhoneNumber(index: number): void {
    this.phoneNumbers.removeAt(index);

    if (this.phoneNumbers.length === 0) {
      this.addPhoneNumber();
    }
  }

  phoneNumberValidator(control: any) {
    if (!control || !control.parent || !control.value) {
      return null;
    }

    const phoneNumber = control.value;
    const prefix = control.parent.get('prefix')?.value;
    const isValid = PhoneNumberHelper.isValidPhoneFormat(phoneNumber, prefix);

    return isValid ? null : { invalidPhoneNumber: true };
  }

  isOtherPrefix(index: number): boolean {
    const group = this.getPhoneNumberFormGroup(index);
    const prefix = group.get('prefix')?.value;
    return prefix ? PhoneNumberHelper.isOtherPrefix(prefix) : false;
  }
}
